import { ListStatusTag } from '@/components/list-status-tag/list-status-tag';
import { TableSecondaryCell } from '@/ui/table/infinite-table/table-cells';

export const ProjectStageCell = ({ stage }: { stage: string | null }) => {
  if (!stage) {
    return <TableSecondaryCell />;
  }
  return <ListStatusTag text={stage} />;
};
